import { createContext, useContext } from "react";

export interface ScaleTarget {
    factor: number;
    index?: number;
}

export interface RecipeDisplayContext {
    fractionAsNumber: boolean;
    scale?: ScaleTarget;
}

export interface RecipeDisplayControl {
    addRecipe?: () => void;
    removeRecipe?: () => void;
    showRevisions?: () => void;
}

export const RecipeDisplayContext = createContext<RecipeDisplayContext>({
    fractionAsNumber: false,
});

export const RecipeDisplayControlContext = createContext<RecipeDisplayControl | undefined>(undefined);

export function useRecipeDisplayContext() {
    return useContext(RecipeDisplayContext);
}

export function useRecipeDisplayControlContext() {
    return useContext(RecipeDisplayControlContext);
}
